import React from 'react';
import type { Props as SelectProps } from 'react-select';
import MaterialIcon from '../../icon/Icon.material';
import { GLOBAL_ICONS } from '../../../util/vars';
import { SELECTOR_ICON_CLEAR } from '../../../util/data-id';

const CustomClearIndicator: React.FC<SelectProps> = ({ size, ...props }) => {
  const {
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div {...restInnerProps} ref={ref} className={'cursor-pointer'}>
      <MaterialIcon data-selector={SELECTOR_ICON_CLEAR} icon={GLOBAL_ICONS.close} size={size} color={'dark'} />
    </div>
  );
};

export default CustomClearIndicator;
